import jsPDF from 'jspdf';
import { format, parse } from 'date-fns';

export const generateAppointmentPDF = (appointmentData) => {
  // Create a new PDF document
  const doc = new jsPDF();
  
  // Set font
  doc.setFont('helvetica');
  
  // Header
  doc.setFontSize(20);
  doc.setTextColor(59, 130, 246); // Blue color
  doc.text('APPOINTMENT CONFIRMATION', 20, 30);
  
  // Horizontal line
  doc.setDrawColor(59, 130, 246);
  doc.setLineWidth(0.5);
  doc.line(20, 35, 190, 35);
  
  // Reset color
  doc.setTextColor(0, 0, 0);
  
  // Confirmation details
  doc.setFontSize(14);
  doc.text('Confirmation Code:', 20, 55);
  doc.setFontSize(12);
  doc.setFont('helvetica', 'bold');
  doc.text(appointmentData.confirmation_code || 'N/A', 70, 55);
  doc.setFont('helvetica', 'normal');
  
  doc.setFontSize(14);
  doc.text('Appointment Details:', 20, 75);
  
  // Appointment information
  doc.setFontSize(12);
  const details = [
    ['Name:', appointmentData.visitor_name || 'N/A'],
    ['Email:', appointmentData.visitor_email || 'N/A'],
    ['Phone:', appointmentData.visitor_phone || 'N/A'],
    ['Date:', appointmentData.appointment_date ? format(parse(appointmentData.appointment_date, 'yyyy-MM-dd', new Date()), 'MMMM dd, yyyy') : 'N/A'],
    ['Time:', appointmentData.appointment_time || 'N/A'],
    ['Type:', appointmentData.appointment_type || 'Consultation']
  ];
  
  let yPosition = 85;
  details.forEach(([label, value]) => {
    doc.text(label, 25, yPosition);
    doc.text(value, 70, yPosition);
    yPosition += 10;
  });
  
  // Meeting Information Section
  yPosition += 10;
  doc.setFontSize(14);
  doc.text('Meeting Access Information:', 20, yPosition);
  yPosition += 15;
  
  doc.setFontSize(12);
  doc.text('To join the meeting, click this URL:', 20, yPosition);
  yPosition += 8;
  doc.setTextColor(0, 0, 255);
  doc.text('https://meetn.com/drlionelmaten', 20, yPosition);
  yPosition += 15;
  
  doc.setTextColor(0, 0, 0);
  doc.text('Or, dial this number from the U.S.:', 20, yPosition);
  yPosition += 8;
  doc.setFont('helvetica', 'bold');
  doc.text('+1-859-710-9286', 20, yPosition);
  yPosition += 10;
  doc.setFont('helvetica', 'normal');
  doc.text('PIN: 8178007', 20, yPosition);
  yPosition += 15;
  
  doc.text('P.S. International dial-in numbers are available at', 20, yPosition);
  yPosition += 8;
  doc.setTextColor(0, 0, 255);
  doc.text('https://meetn.com/Numbers', 20, yPosition);
  
  // Notes section
  if (appointmentData.notes) {
    yPosition += 20;
    doc.setTextColor(0, 0, 0);
    doc.setFontSize(14);
    doc.text('Notes:', 20, yPosition);
    yPosition += 10;
    doc.setFontSize(12);
    
    // Split long notes into multiple lines
    const notes = doc.splitTextToSize(appointmentData.notes, 170);
    doc.text(notes, 20, yPosition);
  }
  
  // Footer
  const footerY = 280;
  doc.setFontSize(10);
  doc.setTextColor(128, 128, 128);
  doc.text('Generated on: ' + format(new Date(), 'PPP'), 20, footerY);
  doc.text('Please save this confirmation for your records.', 20, footerY + 8);
  
  return doc;
};

export const downloadPDF = (appointmentData, filename) => {
  try {
    console.log('Generating PDF for appointment:', appointmentData);
    const doc = generateAppointmentPDF(appointmentData);
    const defaultFilename = `appointment-confirmation-${appointmentData.confirmation_code || 'unknown'}.pdf`;
    doc.save(filename || defaultFilename);
    console.log('PDF saved successfully');
  } catch (error) {
    console.error('Error generating PDF:', error);
    // Fallback: create a simple text download if PDF generation fails
    const textContent = `
APPOINTMENT CONFIRMATION
========================

Confirmation Code: ${appointmentData.confirmation_code || 'N/A'}

Appointment Details:
- Name: ${appointmentData.visitor_name || 'N/A'}
- Email: ${appointmentData.visitor_email || 'N/A'}
- Phone: ${appointmentData.visitor_phone || 'N/A'}
- Date: ${appointmentData.appointment_date ? format(parse(appointmentData.appointment_date, 'yyyy-MM-dd', new Date()), 'MMMM dd, yyyy') : 'N/A'}
- Time: ${appointmentData.appointment_time || 'N/A'}
- Type: ${appointmentData.appointment_type || 'Consultation'}

Meeting Access Information:
- Virtual Meeting: https://meetn.com/drlionelmaten
- Phone Access: +1-859-710-9286 (PIN: 8178007)
- International Numbers: https://meetn.com/Numbers

${appointmentData.notes ? `Notes: ${appointmentData.notes}` : ''}

Generated on: ${format(new Date(), 'PPP')}
Please save this confirmation for your records.
    `;
    
    const blob = new Blob([textContent], { type: 'text/plain' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename || `appointment-confirmation-${appointmentData.confirmation_code || 'unknown'}.txt`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }
};